export var LinkTypes;

(function (LinkTypes) {
  LinkTypes["PRIMARY"] = "primary";
  LinkTypes["SECONDARY"] = "secondary";
  LinkTypes["INVERSE"] = "inverse";
  LinkTypes["ACTION"] = "action";
  LinkTypes["INLINE"] = "inline";
})(LinkTypes || (LinkTypes = {}));